import React from 'react';
import { BooleanInput, BooleanField,Filter, maxLength, SearchInput, SelectInput,AutocompleteInput,DateInput} from 'react-admin';

const FiltreAllOrders=(props)=>{

    const {listCamps}=props;

    return (
        <Filter {...props} >
            <SearchInput source="q" alwaysOn  validate={maxLength(8)} />
            <DateInput source="start_date" label="Date début"  alwaysOn />
            <DateInput source="end_date" label="Date fin"  alwaysOn />
            <SelectInput
                source="orderStatus"
                label="Status facture" 
                choices={[
                    { id: 'ATTENTE', name: 'En attente' },
                    { id: 'APPV', name: 'Approuvé' },
                    { id: 'ANNULER', name: 'Annuler' },
                    { id: 'DEVIS', name: 'Dévis' },
                ]}
                allowEmpty={false}
            />

            <AutocompleteInput
                source="camp_id"
                label="Campagne" 
                choices={listCamps}
                allowEmpty={false}
            />
            <BooleanInput  source="urgent" fullWidth label="Urgent"   />
            <BooleanInput  source="rest_a_payer" label="Reste à payer"   />
            <BooleanInput  source="gratuit_excep"  label="Gratuit exceptionnel"  />
            <SelectInput
                source="client"
                label="Client" 
                choices={[
                    { id: 'cli_exp', name: 'Nom Client exp' },
                    { id: 'tel_exp', name: 'Tel Client exp' },
                    { id: 'cli_dest', name: 'Nom Client dest' },
                    { id: 'tel_dest', name: 'Tel Client dest' },
                ]}
                allowEmpty={false}
            />
            
        </Filter>
    );

}

export default FiltreAllOrders;